import axiosDonation from "./axiosDonation";

const recycledProductApi = {
  create: (data: any) => {
    const url = "/serene/recycled-product/create";
    return axiosDonation.post(url, data);
  },

  update: (data: any) => {
    const url = "/serene/recycled-product/update";
    return axiosDonation.post(url, data);
  },

  delete: (data: any) => {
    const url = "/serene/recycled-product/delete";
    return axiosDonation.post(url, data);
  },

  getList: (data: any) => {
    const url = "/serene/recycled-product/list";
    return axiosDonation.post(url, data);
  },
};

export default recycledProductApi;
